export default __webpack_public_path__ + "static/media/bashir.44de1746.png";